// taxi management

import axios from "axios";
import { API_BASE_URL } from "@/constants";

const state = {
  intervel: [
    {
      id: 1,
      name: "1 minute",
      time: 60
    },
    {
      id: 2,
      name: "5 minutes",
      time: 300
    },
    {
      id: 3,
      name: "10 minutes",
      time: 600
    },
    {
      id: 4,
      name: "15 minutes",
      time: 900
    },
    {
      id: 5,
      name: "30 minutes",
      time: 1800
    },
    {
      id: 6,
      name: "1 hour",
      time: 3600
    },
    {
      id: 7,
      name: "2 hours",
      time: 7200
    },
    {
      id: 8,
      name: "4 hours",
      time: 14400
    },
    {
      id: 9,
      name: "6 hours",
      time: 21600
    },
    {
      id: 10,
      name: "12 hours",
      time: 43200
    },
    {
      id: 11,
      name: "1 day",
      time: 86400
    },
    {
      id: 12,
      name: "2 days",
      time: 172800
    }
  ],
  data: [],
  loading: false
};

const getters = {
  data: state => state.data,
  intervel: state => state.intervel
};

const actions = {};

const mutations = {
  LOADIND_TAXI(state, payload) {
    state.loading = payload.loading;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
